'use strict'

import store from "@/libs/store";

let sleep = async seconds => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve()
        }, 1000 * seconds);
    })
}

export default async (to, from, next) => {
    store.state.template = 'loading'
    //await sleep(5)
    //return true
    if (localStorage.getItem('auth') === null) {
        next('/portada')
    }
    else {
        return true
    }
}



/*import store from '@/libs/store'

export default async (to, from, next) => {
    console.log('enter to existToken')
    store.state.template = 'loading'
    await sleep(1.2)
    console.log('auth')
    return true
    to('login')
    if (localStorage.getItem('auth') === null) {
        return true
    }
    else {
        return true
    }
}*/
